export const DEFAULT_ASCENDING = true;
export const DEFAULT_LIMIT: number | undefined = undefined;
export const DEFAULT_INFINITE_LIMIT = 30;
export const DEFAULT_INFINITE_SELECT_LIMIT = 30;
export const DEFAULT_SEARCH_DEBOUNCE_MS = 250;
export const DEFAULT_WILDCARD_CHAR = "*";
